import { Drawer } from "@components";
import { Titles } from "../../variables/Titles";

import VariableValueForm from "../types/VariableValueForm";

export const OrderTemperatureForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
  onRemove,
}) => {
  const input_configs = {
    type: "currency",
    prefix: "",
    suffix: "°C",
    precision: 2,
  };

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={Titles.OrderTemperature}
      direction="center-right"
      parentSelector={() => document.getElementById("oracle-flow")}
    >
      <VariableValueForm
        node={node}
        input_configs={input_configs}
        onSave={(node) => onSave(node)}
        onRemove={onRemove}
      />
    </Drawer>
  );
};
